import React from 'react';

import cn from 'clsx';

import { uniqueId } from '@helpers/unuqueId';

export enum CheckboxLabelPosition {
  Before,
  After,
}

interface IPohCheckboxProps extends Omit<React.HTMLAttributes<HTMLInputElement>, 'onChange'> {
  labelPosition?: CheckboxLabelPosition;
  label?: React.ReactNode;
  id?: string;
  checked?: boolean;
  disabled?: boolean;
  required?: boolean;
  inline?: boolean;
  name?: string;
  onChange?: (checked: boolean, e: React.ChangeEvent<HTMLInputElement>) => void;
}

const PohCheckbox: React.FC<IPohCheckboxProps> = ({
  className,
  label,
  id,
  labelPosition = CheckboxLabelPosition.After,
  onChange,
  inline = false,
  ...rest
}) => {
  const uId = id || uniqueId('pohCheckbox');
  return (
    <div className={cn('form-check', { 'form-check-inline': inline })}>
      {label && labelPosition === CheckboxLabelPosition.Before && (
        <label className="form-check-label" htmlFor={uId}>
          {label}
        </label>
      )}
      <input
        type="checkbox"
        id={uId}
        className={cn('form-check-input', { 'position-static': !label }, className)}
        onChange={(event) => onChange?.(event.target.checked, event)}
        {...rest}
      />
      {label && labelPosition === CheckboxLabelPosition.After && (
        <label className="form-check-label" htmlFor={uId}>
          {label}
        </label>
      )}
    </div>
  );
};

export default PohCheckbox;
